import { useEffect } from 'react';
import { areFeatureFlagsLoaded, useFeatureFlags, useLanguageSwitcherEnabled } from './useFeatureFlags';
import { setLanguageLockedToRussian } from '../i18n';

/**
 * CORE-1715 — без переключателя языка интерфейс показывает русский.
 *
 * Флаг `language_switcher` прячет переключатель, но язык, выбранный раньше
 * (или подобранный по испанскому браузеру), оставался — и вернуться на русский
 * было нечем. Пока флаг выключен, держим русский; включили — человек получает
 * свой язык обратно, потому что выбор нигде не перезаписан.
 *
 * Так и в вебе, и в приложении (CORE-1306): там тот же флаг прячет строку
 * «Язык» в бургер-меню и блок в «Настройках», а выбор, сделанный раньше,
 * лежит в AsyncStorage и поднимается при старте.
 *
 * До первого ответа `/api/features` ничего не делаем: пустая карта флагов здесь
 * не значит «выключено», и при включённом флаге язык не должен мигать на
 * русский. Зависимость — вся карта: у отсутствующего флага ответ хука `false`
 * и до загрузки, и после, а карта меняется с первым ответом.
 */
export function useLanguageSwitcherGate(): void {
  const flags = useFeatureFlags();
  const enabled = useLanguageSwitcherEnabled();
  useEffect(() => {
    if (!areFeatureFlagsLoaded()) return;
    void setLanguageLockedToRussian(!enabled);
  }, [flags, enabled]);
}
